"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PriorityBadge = exports.badgeTheme = void 0;

var React = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _blocks = require("@bueno/blocks");

const badgeTheme = {
  1: {
    background: _blocks.palette.red7,
    foreground: _blocks.color.pureWhite
  },
  2: {
    background: _blocks.palette.red5,
    foreground: _blocks.color.pureWhite
  },
  3: {
    background: _blocks.color.pureWhite,
    foreground: _blocks.palette.neutral7
  },
  // HACK: This variation isn't visible, see comment below
  0: {
    background: _blocks.color.pureWhite,
    foreground: _blocks.palette.neutral7
  }
}; // HACK: Used to hide the priority when its value is 0

exports.badgeTheme = badgeTheme;
const StyledBadge = (0, _styledComponents.default)(_blocks.Badge)`
  visibility: ${props => props.isHidden ? 'hidden' : 'visible'};
`;

const PriorityBadge = ({
  priority
}) => {
  return /*#__PURE__*/React.createElement(StyledBadge, {
    isHidden: priority === 0,
    foregroundColor: badgeTheme[priority].foreground,
    backgroundColor: badgeTheme[priority].background
  }, /*#__PURE__*/React.createElement(_blocks.ArrowPointUp, {
    tiny: true
  }), "\xA0P", priority);
};

exports.PriorityBadge = PriorityBadge;